import React from 'react';
import PartnerInvitationsResponded from './PartnerInvitationsResponded';
import PartnerInvitationsCreated from './PartnerInvitationsCreated';
import PercentPartnerInvitationsResponded from './PercentPartnerInvitationsResponded';

export default function EducatorsWithCompletedProjectGroup(props) {
  return (
    <>
      <PercentPartnerInvitationsResponded {...props} />
      <PartnerInvitationsResponded {...props} />
      <PartnerInvitationsCreated {...props} />
    </>
  )
}
